import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import VirtualTransactionsDownloadModalUI from './VirtualTransactionsDownLoadModalUI'

class VirtualTransactionsDownloadModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      format: 'pdf',
      formatError: null
    }
  }

  render() {
    let formatList = [
      { key: 'pdf', value: 'PDF' },
      { key: 'excel', value: 'Excel' }
    ]
    return (
      <VirtualTransactionsDownloadModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        downloadMode={this.props.downloadMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        bankAccountNumber={this.props.bankAccountNumber}
        formatList={formatList}
        format={this.state.format}
        onFormatChange={(event) => { this.setState({ format: event.target.value }) }}
        formatError={this.state.formatError}
        setFormatError={(error) => { this.setState({ formatError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.get(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/virtualAccounts/${this.props.bankAccountNumber}/transactions/fileDownloadSignedUrl`,
      this.onSubmitCallback, null, {
      year: this.props.year,
      period: this.props.period,
      format: this.state.format
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
      }, 1000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default VirtualTransactionsDownloadModalSF
